import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/siteConfig';

const footerLinks = [
  {
    title: '学习资源',
    links: [
      { to: '/category/darknet-basics', label: '暗网基础认知' },
      { to: '/category/operation-mechanism', label: '暗网运作机制' },
      { to: '/category/risk-identification', label: '暗网风险识别' },
    ],
  },
  {
    title: '安全防护',
    links: [
      { to: '/category/personal-protection', label: '个人信息防护' },
      { to: '/category/legal-compliance', label: '法律法规解读' },
      { to: '/category/case-analysis', label: '案例分析与警示' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { to: '/about', label: '品牌介绍' },
      { to: '/about', label: '联系我们' },
      { to: '/', label: '回到首页' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-amber-500">
                <i className="ri-shield-flash-line text-white text-lg"></i>
              </div>
              <span className="text-lg font-semibold text-white tracking-tight">{siteConfig.name}</span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              {siteConfig.description}
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href={siteConfig.social.weibo} target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-amber-500 text-foreground-400 hover:text-white transition-colors duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-amber-500 text-foreground-400 hover:text-white transition-colors duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-white mb-4">{group.title}</h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-400 hover:text-amber-400 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {siteConfig.name}. 本站内容仅供学习参考，请勿用于非法用途。
          </p>
          <div className="flex items-center gap-4">
            <a href="https://www.12377.cn" target="_blank" rel="nofollow noopener noreferrer" className="text-xs text-foreground-500 hover:text-amber-400 transition-colors duration-200 cursor-pointer">违法和不良信息举报中心</a>
            <span className="text-xs text-foreground-600">|</span>
            <a href="#" className="text-xs text-foreground-500 hover:text-amber-400 transition-colors duration-200 cursor-pointer">隐私政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}